// Vuetify
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";
import { createVuetify } from "vuetify";
import { pt } from "vuetify/locale";
//import { VDataTable } from "vuetify/labs/VDataTable";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import * as labsComponents from "vuetify/labs/components";

const savedTheme = localStorage.getItem("aom-theme") || "light";

const vuetify = createVuetify({
	locale: {
		locale: "pt",
		fallback: "en",
		messages: { pt },
	},
	date: {
		locale: {
			pt: "pt-BR",
		},
	},
	theme: {
		defaultTheme: savedTheme,
		themes: {
			light: {
				dark: false,
				colors: {
					primary: "#1e7c73",
					// Marca: repintada em tempo de execucao pela cor do sistema.
					marca: "#0D47A1",
					"marca-escura": "#092E68",
					"marca-clara": "#4E7BBD",
					"marca-suave": "#E7EDF6",
					"marca-tenue": "#F4F7FB",
					"sobre-marca": "#FFFFFF",
					"primary-lighten-1": "#30a59d",
					"primary-darken-1": "#1e5c58",
					error: "#AE2424",
					background: "#f1f5f9",
					surface: "#ffffff",
				},
			},
			dark: {
				dark: true,
				colors: {
					primary: "#30a59d",
					marca: "#4E7BBD",
					"marca-escura": "#092E68",
					"marca-clara": "#7FA3D3",
					"marca-suave": "#092E68",
					"marca-tenue": "#092E68",
					"sobre-marca": "#FFFFFF",
					"primary-lighten-1": "#4dc4bb",
					"primary-darken-1": "#1e7c73",
					error: "#cf4444",
					background: "#0d1117",
					surface: "#161b22",
				},
			},
		},
	},
	components: {
		//VDataTable,
		...components,
		...labsComponents,
	},
	directives,
});

export default vuetify;
